import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IParentSubjectResponse,
  IParentSubjectState,
  IParentSyllabusResponse,
} from '../../interface/parentSubject.interface';
import { fetchParentSubjects, fetchParentSyllabus } from '../action/parentSubject.action';

const initialState: IParentSubjectState = {
  subjects: [],
  loading: false,
  error: null,
  syllabus: [],
  syllabusLoading: false,
  syllabusError: null,
};

const parentSubjectSlice = createSlice({
  name: 'parentSubject',
  initialState,
  reducers: {
    // The page dispatches this on mount and on child switch, so one child's
    // subjects never flash on another child's screen.
    resetParentSubjectState: () => initialState,
    /**
     * Clears ONLY the syllabus slice when the viewer closes the panel, so the
     * previous subject's lines are not what they see for a moment the next
     * time they open one.
     */
    clearParentSyllabus: (state) => {
      state.syllabus = [];
      state.syllabusError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchParentSubjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchParentSubjects.fulfilled,
        (state, action: PayloadAction<IParentSubjectResponse>) => {
          state.loading = false;
          state.subjects = action.payload.data?.subjects || [];
          state.error = null;
        },
      )
      .addCase(fetchParentSubjects.rejected, (state, action) => {
        state.loading = false;
        state.subjects = [];
        state.error = action.payload?.message || 'Failed to fetch subjects.';
      })
      .addCase(fetchParentSyllabus.pending, (state) => {
        state.syllabusLoading = true;
        state.syllabusError = null;
      })
      .addCase(
        fetchParentSyllabus.fulfilled,
        (state, action: PayloadAction<IParentSyllabusResponse>) => {
          state.syllabusLoading = false;
          state.syllabus = action.payload.data?.syllabus || [];
          state.syllabusError = null;
        },
      )
      .addCase(fetchParentSyllabus.rejected, (state, action) => {
        state.syllabusLoading = false;
        state.syllabus = [];
        state.syllabusError = action.payload?.message || 'Failed to fetch the syllabus.';
      });
  },
});

export const { resetParentSubjectState, clearParentSyllabus } = parentSubjectSlice.actions;
export default parentSubjectSlice.reducer;
